export interface BasketOptionItem {
  optionValueID: string;
  label: string;
}

export const basketOptionItemFromResponse = (
  responseData: any,
): BasketOptionItem => ({
  optionValueID: responseData.option_value_id,
  label: responseData.label,
});

export interface BasketOption {
  item: BasketOptionItem;
}

export const basketOptionFromResponse = (responseData: any): BasketOption => ({
  item: basketOptionItemFromResponse(responseData.item),
});
